import React, { useState } from 'react'

// redux
import { connect } from "react-redux";

// react-bootstrap
import { Modal } from 'react-bootstrap';

// bootstrap
import { Spinner } from 'react-bootstrap';

// styles
import { HeaderSearchContent } from '../../styles/styles.header'

// icons
import {
    FiSearch
} from "react-icons/fi";

// forms
import FormInput from 'utlis/Forms/FormInput'

// helpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions';

// react toastify
import { toast } from "react-toastify";

// component
import SearchItem from './SearchItem';

// api
import { getProducts } from "utlis/Apis/Products_API";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

function ModalSearch(props) {
    // props
    const {
        handleSearchModalClose,
        handleSearchModalOpen,
        searchModalVisibility,

        searchRef,

        commonToken
    } = props

    // states
    const [searchResults, setSearchResults] = useState([])
    const [searchResultsImage, setSearchResultsImage] = useState([]);
    const [dataLoading, setDataLoading] = useState(false)
    const [noDataFound, setNoDataFound] = useState(false)

    // search product
    const handleSearchProduct = debounce(ev => {
        const inpVal = ev.target.value

        if (inpVal) {
            // loading
            setDataLoading(true)

            // fetching data
            let URLParams = `keyword=${inpVal}&page=1&limit=10`

            getProducts(commonToken ?? "", URLParams).then(res => {
                // disabling loading
                setDataLoading(false)

                const resData = res.data
                // if request succesfull
                if (resData && resData.success) {
                    if (resData?.data?.length) {
                        // settings products
                        setSearchResults(resData.data)
    
                        // settings images
                        const imagedObj = resData.images
                        setSearchResultsImage(imagedObj)
                    } else {
                        // setting no data
                        setNoDataFound(true)
                    }
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                    });
                }
            }).catch(err => {
                console.log(
                    `${ERROR_WHILE__NAME} getProducts `,
                    err.message
                );

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling loading
                        setDataLoading(false)
                    },
                });
            })

        } else {
            // loading
            setDataLoading(false)

            // setting data
            setSearchResults([])

            // setting no data
            setNoDataFound(false)
        }
    }, 300)

    return (
        <Modal
            show={searchModalVisibility}
            onHide={handleSearchModalClose}
            onShow={handleSearchModalOpen}
            className="st-modal"
            centered>
            {/* header */}
            <Modal.Header closeButton>
                <Modal.Title className="text-center w-100">Search</Modal.Title>
            </Modal.Header>

            {/* body */}
            <Modal.Body>
                <FormInput
                    formClassName="form-lg mb-0"
                    placeholder="Search our store..."
                    icon={
                        <FiSearch />
                    }
                    inputRef={searchRef}
                    onChange={handleSearchProduct}
                />

                {/* SEARCH CONTENT */}
                {
                    dataLoading ? (
                        <div className="loading d-flex justify-content-center pt-3">
                            <Spinner animation="border" size="sm" />
                        </div>
                    ) : (
                        <>
                            {
                                searchResults?.length ? (
                                    <HeaderSearchContent className="pt-3">
                                        <div className="inner">
                                            {
                                                searchResults.map(item => (
                                                    <SearchItem
                                                        key={item.product_id}

                                                        dataItem={item}

                                                        searchResultsImage={searchResultsImage}

                                                        handleSearchModalClose={handleSearchModalClose}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </HeaderSearchContent>
                                ) : (
                                    <>
                                        {
                                            noDataFound ? (
                                                <p className="no-result mb-0 pt-3 text-center st-text-black-light">
                                                    no result found
                                                </p>
                                            ) : null
                                        }
                                    </>
                                )
                            }
                        </>
                    )
                }
            </Modal.Body>
        </Modal>
    )
}

const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {

    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(ModalSearch);